import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MenuItem as MuiMenuItem } from '@material-ui/core';
import cn from 'classnames';
import { useBiContextGetter } from '../BiTracking/BiContext';
import { ConditionalWrapper } from '../ConditionalWrapper';
import { useIntentBehavior } from '../IntentBehavior';
import { Tooltip } from '../Tooltip';
import { useMenuItemStyles } from './MenuItem.styles';
import { MenuItemTestIds } from './MenuItem.utils';
export const MenuItem = /*#__PURE__*/ React.forwardRef(function MenuItem(props, ref) {
    const { className, children, value, height, variant = 'singleline', skin = 'secondary', onClick, label, tooltipProps, intent, disabled, testId } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "value",
        "height",
        "variant",
        "skin",
        "onClick",
        "label",
        "tooltipProps",
        "intent",
        "disabled",
        "testId"
    ]);
    const overrides = useMenuItemStyles({
        height,
        variant
    });
    const { getDisabled, getTooltip } = useIntentBehavior();
    const disabledFromIntent = intent ? getDisabled(intent) : false;
    const tooltipFromIntent = intent ? getTooltip(intent) : null;
    const hasTooltip = !!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !!tooltipFromIntent;
    const biContext = useBiContextGetter();
    return /*#__PURE__*/ _jsx(ConditionalWrapper, {
        condition: hasTooltip,
        wrapper: (children)=>/*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({}, tooltipProps || {
                placement: 'top',
                title: tooltipFromIntent
            }), {
                testId: MenuItemTestIds.Tooltip(testId !== null && testId !== void 0 ? testId : ''),
                children: /*#__PURE__*/ _jsx("div", {
                    "data-testid": testId && MenuItemTestIds.Wrapper(testId),
                    children: children
                })
            })),
        children: /*#__PURE__*/ _jsx(MuiMenuItem, _object_spread_props(_object_spread({
            className: cn(overrides.root, overrides[skin], className),
            ref: ref,
            alignItems: "center",
            value: value,
            onClick: (e)=>onClick === null || onClick === void 0 ? void 0 : onClick(e, biContext),
            "data-label": label || children,
            disabled: disabledFromIntent || disabled,
            "data-testid": testId
        }, rest), {
            children: children
        }))
    });
});
